<script lang="jsx">
export default {
  name: 'settlement',
  functional: true,
  props: {},
  render(h, context) {
    const { success, error } = context.listeners
    return (
      <div class="z-result-payment-wrapper z-envelopes-wrapper">
        <div class="z-envelopes-wrapper-content">
          <div class="result-payment-wrapper">
            <div class="tips-text">
              <p>支付完成前，请勿关闭此窗口。</p>
              <p>支付完成后，请根据支付情况点击以下按钮。</p>
            </div>
            <div class="result-button">
              <el-button onClick={error} size="small">
                充值失败
              </el-button>
              <el-button onClick={success} type="primary" size="small">
                充值成功
              </el-button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
</script>

<style lang="scss">
@import '~@/assets/scss/envelopes.scss';

.z-result-payment-wrapper {
  .result-payment-wrapper {
    margin: auto;
  }

  .tips-text {
    text-align: center;
  }

  .result-button {
    margin-top: 30px;
    text-align: center;
  }

  .result-right {
    display: inline-block;
  }
}
</style>
